export default __webpack_public_path__ + "static/media/fight-action-240.51998135.png";